/* global flatpickr */
'use strict'
const formHelper = {
	el: {
		checkboxes: document.querySelectorAll('.js-checkbox'),
		inputsNumber: document.querySelectorAll('.js-number'),
		inputsAnimation: [...document.querySelectorAll('.form__field--text .form__input'), ...document.querySelectorAll('.form__field--select .form__input-select')],
		forms: document.querySelectorAll('.forms-gpf form'),
		inputsToggleField: document.querySelectorAll('.js-toggle-field'),
		inputsCurrency: document.querySelectorAll('.js-currency'),
		inputsDecimals: document.querySelectorAll('.js-decimals'),
		body: document.body
	},

	fxFormToJson: function formToJson(elem) {
		let unindexedArray = $(elem).serializeArray()
			, indexedArray = {}
		$.map(unindexedArray, function(n, i) {
			$(n).each(function() {
				n.value === 'true' || n.value === 'false' ? n.value = JSON.parse(n.value) : ''
			})
			indexedArray[n['name']] = n['value']
		})
		return indexedArray
	},

	fxAcceptOnlyNumbers (e) {
		const input = e.currentTarget
		let key = e.charCode ? e.charCode : e.keyCode

		if(key < 48 || key > 57) e.preventDefault()

		if(input.dataset.date === 'true') {
			if (input.value.length == 1 || input.value.length == 4) {
				input.value = `${input.value}${String.fromCharCode(key)}/`
				e.preventDefault()
			}
		}
	},

	fxShowLoader (form) {
		if ($(form).valid()) {
			$('.spinner-overlay').css('display', 'flex')
			this.el.body.classList.add('no-scroll-hidden')
		}	
	},

	fxRemoveLoader () {
		$('.spinner-overlay').css('display', 'none')
		this.el.body.classList.remove('no-scroll-hidden')
	},

	fxToggleCheckbox(el) {
		el.addEventListener('change', e => {
			if(e.currentTarget.checked) {
				e.currentTarget.value = true
				e.currentTarget.checked = true
			} else {
				e.currentTarget.value = false
				e.currentTarget.removeAttribute('checked')
			}
		})
	},

	fxLabelActive (parent) {
		let classes = ['is-active', 'is-completed']
		parent.classList.add(...classes)
	},

	fxLabelInactive (input, parent) {
		if(input.nodeName === 'SELECT') {
			input.value === '-1' && parent.classList.remove('is-completed')
		} else {
			input.value === '' && parent.classList.remove('is-completed')
		}
		parent.classList.remove('is-active')
	},

	fxCheckInputValues (input, parent) {
		if(input.nodeName === 'SELECT') {
			if(input.value !== '-1') {
				let classes = ['is-active', 'is-completed']
				parent.classList.add(...classes)
			}
		} else {
			if(input.value?.length) {
				let classes = ['is-active', 'is-completed']
				parent.classList.add(...classes)
			}
		}
	},

	fxToggleField (input) {
		const target = document.querySelector(`#${input.dataset.target}`)

		if(input.value === input.dataset.toggleValue) {
			target.parentElement.classList.remove('d-none')
			target.setAttribute('required', '')
		} else {
			target.parentElement.classList.add('d-none')
			target.removeAttribute('required')
		}
	},

	fxCurrencyFocusOut(el) {
		const value = el.value,
			parentElement = el.parentElement,
			currency = el.dataset.currency

		parentElement.classList.remove('input-blur')
		parentElement.dataset.value = `${value} ${currency}`
	},

	fxCurrencyFocusIn(el) {
		const parentElement = el.parentElement
		parentElement.classList.add('input-blur')
	},

	fxCheckDecimals(ev) {
		let key = ev.charCode ? ev.charCode : ev.keyCode
		const decimals = ev.currentTarget.dataset.decimalPlaces,
			keyCode = ev.currentTarget.dataset.decimalDot === 'true' ? 44 : 46,
			punctuation = ev.currentTarget.dataset.decimalDot === 'true' ? '.' : ','

		// only allow numbers, ",", "." "-"
		if ((key < 48 || key > 57) && key !== 44 && key !== 46 && key !== 45) {
			ev.preventDefault()
		}

		//only allow 1 "," or "."
		if (key === 46 || key === 44) {
			const value = ev.currentTarget.value

			if (value.includes(',') || value.includes('.')) {
				ev.preventDefault()
				return
			}
		}

		// replace . with , / replace , with .
		if (key === keyCode) {
			ev.preventDefault()
			ev.currentTarget.value = `${ev.currentTarget.value}${punctuation}`
		}

		// don't allow more then n decimals
		const regx = `^(\\-)?\\d*\\${punctuation}?\\d{0,${Number(decimals - 1)}}?$`

		if (ev.currentTarget.selectionStart > ev.currentTarget.value.indexOf(`${punctuation}`) && !new RegExp(regx).test(ev.currentTarget.value)) {
			ev.preventDefault()
		}
	},

	fxInputEvents() {
		for (const checkbox of this.el.checkboxes)
			this.fxToggleCheckbox(checkbox)

		for (const input of this.el.inputsNumber) {
			input.addEventListener('keypress', e => {
				this.fxAcceptOnlyNumbers(e)
			})
		}

		for (const form of this.el.forms)
			form.addEventListener('submit', e => this.fxShowLoader(e.currentTarget))

		//-label animations on focus/focusout, initial state if input has value
		for(const input of this.el.inputsAnimation) {
			const parent = input.parentElement

			//-on focus
			input.addEventListener('focus', e => this.fxLabelActive(parent))
			//-on focus out
			input.addEventListener('focusout', e => this.fxLabelInactive(e.currentTarget, parent))
			//-initial state
			this.fxCheckInputValues(input, parent)
		}

		//currency
		for(const input of this.el.inputsCurrency) {
			//initiate
			this.fxCurrencyFocusOut(input)
			//attach events
			input.addEventListener('focusin', e => {
				e.currentTarget.readOnly === false && this.fxCurrencyFocusIn(e.target)
			})

			input.addEventListener('focusout', e => {
				e.currentTarget.readOnly === false && this.fxCurrencyFocusOut(e.target)
			})
		}

		//decimals
		for (const input of this.el.inputsDecimals)
			input.addEventListener('keypress', e => this.fxCheckDecimals(e))

		//toggle conditional field
		for(const input of this.el.inputsToggleField)
			input.addEventListener('change', e => this.fxToggleField(e.currentTarget))
	},

	init() {
		this.fxInputEvents()
	}
}

formHelper.init()